import React, { memo } from 'react';
import { CloudRainIcon, CloudSnowIcon, SunIcon, CloudIcon } from 'lucide-react';
// Mock weather data for destinations
export const destinationWeather = {
  Japan: {
    months: [{
      month: 'Jan',
      tempRange: '2-10°C',
      rainfall: 'High',
      icon: <CloudSnowIcon className="h-4 w-4" data-id="element-4286" />,
      season: 'Winter',
      description: 'Cold winter with occasional snow in Tokyo, heavy snowfall in northern regions.'
    }, {
      month: 'Feb',
      tempRange: '2-10°C',
      rainfall: 'High',
      icon: <CloudSnowIcon className="h-4 w-4" data-id="element-4287" />,
      season: 'Winter',
      description: 'Cold winter continues with some snow and rain.'
    }, {
      month: 'Mar',
      tempRange: '5-13°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4288" />,
      season: 'Spring',
      description: 'Early spring with cherry blossoms beginning to bloom in southern regions.'
    }, {
      month: 'Apr',
      tempRange: '10-18°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4289" />,
      season: 'Spring',
      description: 'Peak cherry blossom season with pleasant temperatures.'
    }, {
      month: 'May',
      tempRange: '14-23°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4290" />,
      season: 'Spring',
      description: 'Late spring with warm days and cool evenings.'
    }, {
      month: 'Jun',
      tempRange: '19-25°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4291" />,
      season: 'Summer',
      description: 'Early summer with increasing humidity and rainfall (rainy season).'
    }, {
      month: 'Jul',
      tempRange: '22-29°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4292" />,
      season: 'Summer',
      description: 'Hot and humid with occasional heavy rainfall.'
    }, {
      month: 'Aug',
      tempRange: '24-31°C',
      rainfall: 'Moderate',
      icon: <SunIcon className="h-4 w-4" data-id="element-4293" />,
      season: 'Summer',
      description: 'Peak summer with high temperatures and humidity.'
    }, {
      month: 'Sep',
      tempRange: '20-27°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4294" />,
      season: 'Autumn',
      description: 'Early autumn with typhoon season at its peak.'
    }, {
      month: 'Oct',
      tempRange: '14-22°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4295" />,
      season: 'Autumn',
      description: 'Pleasant autumn with cooler temperatures and autumn foliage beginning.'
    }, {
      month: 'Nov',
      tempRange: '9-17°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4296" />,
      season: 'Autumn',
      description: 'Late autumn with beautiful fall colors and crisp air.'
    }, {
      month: 'Dec',
      tempRange: '3-12°C',
      rainfall: 'Low',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4297" />,
      season: 'Winter',
      description: 'Early winter with cool to cold temperatures.'
    }],
    bestTimeToVisit: ['Mar', 'Apr', 'May', 'Oct', 'Nov'],
    specialEvents: [{
      month: 'Mar-Apr',
      name: 'Cherry Blossom Season',
      description: 'Experience the iconic sakura bloom throughout the country'
    }, {
      month: 'Jul-Aug',
      name: 'Summer Festivals',
      description: 'Numerous traditional festivals with fireworks and celebrations'
    }, {
      month: 'Oct-Nov',
      name: 'Autumn Foliage',
      description: 'Spectacular red and gold autumn colors in parks and mountains'
    }],
    climateScore: 85
  },
  Italy: {
    months: [{
      month: 'Jan',
      tempRange: '3-12°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4298" />,
      season: 'Winter',
      description: 'Cool winter with some rainfall, occasional snow in northern regions.'
    }, {
      month: 'Feb',
      tempRange: '4-13°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4299" />,
      season: 'Winter',
      description: 'Cool temperatures with early spring blooms beginning in some areas.'
    }, {
      month: 'Mar',
      tempRange: '6-16°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4300" />,
      season: 'Spring',
      description: 'Early spring with warming temperatures and blooming flowers.'
    }, {
      month: 'Apr',
      tempRange: '9-19°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4301" />,
      season: 'Spring',
      description: 'Pleasant spring weather with occasional showers.'
    }, {
      month: 'May',
      tempRange: '13-24°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4302" />,
      season: 'Spring',
      description: 'Warm days and mild evenings with less rainfall.'
    }, {
      month: 'Jun',
      tempRange: '17-28°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4303" />,
      season: 'Summer',
      description: 'Early summer with warm temperatures and sunny days.'
    }, {
      month: 'Jul',
      tempRange: '20-31°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4304" />,
      season: 'Summer',
      description: 'Hot summer weather with very little rainfall.'
    }, {
      month: 'Aug',
      tempRange: '20-31°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4305" />,
      season: 'Summer',
      description: 'Peak summer heat with crowded tourist destinations.'
    }, {
      month: 'Sep',
      tempRange: '17-27°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4306" />,
      season: 'Autumn',
      description: 'Pleasant early autumn with warm days and cooler evenings.'
    }, {
      month: 'Oct',
      tempRange: '12-22°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4307" />,
      season: 'Autumn',
      description: 'Mild autumn weather with increasing rainfall.'
    }, {
      month: 'Nov',
      tempRange: '8-17°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4308" />,
      season: 'Autumn',
      description: 'Late autumn with cooler temperatures and increased rainfall.'
    }, {
      month: 'Dec',
      tempRange: '4-13°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4309" />,
      season: 'Winter',
      description: 'Cool winter temperatures with festive holiday atmosphere.'
    }],
    bestTimeToVisit: ['Apr', 'May', 'Jun', 'Sep', 'Oct'],
    specialEvents: [{
      month: 'Feb',
      name: 'Venice Carnival',
      description: 'Elaborate masks and costumes fill the streets of Venice'
    }, {
      month: 'Jun-Aug',
      name: 'Summer Opera Season',
      description: 'Open-air opera performances in historic venues'
    }, {
      month: 'Sep-Oct',
      name: 'Grape Harvest',
      description: 'Wine regions celebrate the harvest with festivals and tastings'
    }],
    climateScore: 90
  },
  Indonesia: {
    months: [{
      month: 'Jan',
      tempRange: '24-31°C',
      rainfall: 'Very High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4310" />,
      season: 'Wet',
      description: 'Peak of wet season with frequent heavy rainfall.'
    }, {
      month: 'Feb',
      tempRange: '24-31°C',
      rainfall: 'Very High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4311" />,
      season: 'Wet',
      description: 'Continuing wet season with high humidity and rainfall.'
    }, {
      month: 'Mar',
      tempRange: '24-31°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4312" />,
      season: 'Wet',
      description: 'Late wet season with decreasing rainfall.'
    }, {
      month: 'Apr',
      tempRange: '24-32°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4313" />,
      season: 'Transition',
      description: 'Transition to dry season with decreasing rainfall.'
    }, {
      month: 'May',
      tempRange: '24-32°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4314" />,
      season: 'Dry',
      description: 'Beginning of dry season with sunny days and lower humidity.'
    }, {
      month: 'Jun',
      tempRange: '23-31°C',
      rainfall: 'Very Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4315" />,
      season: 'Dry',
      description: 'Dry season with sunny days and pleasant evenings.'
    }, {
      month: 'Jul',
      tempRange: '23-31°C',
      rainfall: 'Very Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4316" />,
      season: 'Dry',
      description: 'Peak dry season with consistent sunshine and low humidity.'
    }, {
      month: 'Aug',
      tempRange: '23-31°C',
      rainfall: 'Very Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4317" />,
      season: 'Dry',
      description: 'Continuing dry season with ideal beach conditions.'
    }, {
      month: 'Sep',
      tempRange: '23-31°C',
      rainfall: 'Very Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4318" />,
      season: 'Dry',
      description: 'Late dry season with perfect weather conditions.'
    }, {
      month: 'Oct',
      tempRange: '24-32°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4319" />,
      season: 'Transition',
      description: 'Transition period with increasing humidity.'
    }, {
      month: 'Nov',
      tempRange: '24-32°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4320" />,
      season: 'Wet',
      description: 'Early wet season with increasing rainfall.'
    }, {
      month: 'Dec',
      tempRange: '24-31°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4321" />,
      season: 'Wet',
      description: 'Wet season with frequent rainfall but still warm temperatures.'
    }],
    bestTimeToVisit: ['May', 'Jun', 'Jul', 'Aug', 'Sep'],
    specialEvents: [{
      month: 'Mar',
      name: 'Nyepi (Day of Silence)',
      description: 'Balinese New Year celebrated with purification rituals and a day of silence'
    }, {
      month: 'Jul-Aug',
      name: 'Bali Arts Festival',
      description: 'Month-long celebration of arts, music and cultural performances'
    }, {
      month: 'Oct',
      name: 'Ubud Writers & Readers Festival',
      description: 'International literary festival featuring authors from around the world'
    }],
    climateScore: 80
  },
  Greece: {
    months: [{
      month: 'Jan',
      tempRange: '5-13°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4322" />,
      season: 'Winter',
      description: 'Cool winter with frequent rainfall, especially in coastal areas.'
    }, {
      month: 'Feb',
      tempRange: '6-14°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4323" />,
      season: 'Winter',
      description: 'Cool temperatures with continued rainfall.'
    }, {
      month: 'Mar',
      tempRange: '8-16°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4324" />,
      season: 'Spring',
      description: 'Early spring with warming temperatures and wildflowers beginning to bloom.'
    }, {
      month: 'Apr',
      tempRange: '12-20°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4325" />,
      season: 'Spring',
      description: 'Pleasant spring weather with occasional showers.'
    }, {
      month: 'May',
      tempRange: '16-25°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4326" />,
      season: 'Spring',
      description: 'Warm days with excellent conditions for sightseeing.'
    }, {
      month: 'Jun',
      tempRange: '20-29°C',
      rainfall: 'Very Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4327" />,
      season: 'Summer',
      description: 'Early summer with warm temperatures and abundant sunshine.'
    }, {
      month: 'Jul',
      tempRange: '23-32°C',
      rainfall: 'Very Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4328" />,
      season: 'Summer',
      description: 'Hot summer days with clear skies and warm sea temperatures.'
    }, {
      month: 'Aug',
      tempRange: '23-32°C',
      rainfall: 'Very Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4329" />,
      season: 'Summer',
      description: 'Peak summer heat with crowded beaches and islands.'
    }, {
      month: 'Sep',
      tempRange: '20-29°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4330" />,
      season: 'Summer',
      description: 'Late summer with warm temperatures and fewer crowds.'
    }, {
      month: 'Oct',
      tempRange: '16-24°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4331" />,
      season: 'Autumn',
      description: 'Pleasant autumn weather with warm sea temperatures.'
    }, {
      month: 'Nov',
      tempRange: '11-19°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4332" />,
      season: 'Autumn',
      description: 'Cooling temperatures with increased rainfall.'
    }, {
      month: 'Dec',
      tempRange: '7-15°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4333" />,
      season: 'Winter',
      description: 'Cool winter weather with frequent rainfall.'
    }],
    bestTimeToVisit: ['May', 'Jun', 'Sep', 'Oct'],
    specialEvents: [{
      month: 'Mar',
      name: 'Greek Independence Day',
      description: 'National holiday with parades and celebrations'
    }, {
      month: 'Aug',
      name: 'Assumption Day',
      description: 'Major religious festival with celebrations throughout the country'
    }, {
      month: 'Jun-Sep',
      name: 'Athens & Epidaurus Festival',
      description: 'Cultural festival with performances at ancient theaters'
    }],
    climateScore: 88
  },
  France: {
    months: [{
      month: 'Jan',
      tempRange: '2-8°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4334" />,
      season: 'Winter',
      description: 'Cold winter with frequent rainfall and occasional snow.'
    }, {
      month: 'Feb',
      tempRange: '3-9°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4335" />,
      season: 'Winter',
      description: 'Cold temperatures with less rainfall than January.'
    }, {
      month: 'Mar',
      tempRange: '5-13°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4336" />,
      season: 'Spring',
      description: 'Early spring with warming temperatures and occasional showers.'
    }, {
      month: 'Apr',
      tempRange: '8-16°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4337" />,
      season: 'Spring',
      description: 'Spring weather with flowers blooming and occasional rain.'
    }, {
      month: 'May',
      tempRange: '11-20°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4338" />,
      season: 'Spring',
      description: 'Pleasant temperatures with some rainfall.'
    }, {
      month: 'Jun',
      tempRange: '14-23°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4339" />,
      season: 'Summer',
      description: 'Early summer with warm days and occasional showers.'
    }, {
      month: 'Jul',
      tempRange: '16-25°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4340" />,
      season: 'Summer',
      description: 'Warm summer weather with less rainfall.'
    }, {
      month: 'Aug',
      tempRange: '16-25°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4341" />,
      season: 'Summer',
      description: 'Peak summer with warm temperatures and sunshine.'
    }, {
      month: 'Sep',
      tempRange: '13-22°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4342" />,
      season: 'Autumn',
      description: 'Pleasant early autumn with mild temperatures.'
    }, {
      month: 'Oct',
      tempRange: '10-17°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4343" />,
      season: 'Autumn',
      description: 'Autumn colors with cooling temperatures.'
    }, {
      month: 'Nov',
      tempRange: '5-12°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4344" />,
      season: 'Autumn',
      description: 'Cool temperatures with increased rainfall.'
    }, {
      month: 'Dec',
      tempRange: '3-8°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4345" />,
      season: 'Winter',
      description: 'Cold winter weather with frequent rainfall and occasional snow.'
    }],
    bestTimeToVisit: ['Apr', 'May', 'Jun', 'Sep', 'Oct'],
    specialEvents: [{
      month: 'May',
      name: 'Cannes Film Festival',
      description: 'World-famous film festival on the French Riviera'
    }, {
      month: 'Jun-Jul',
      name: 'Lavender Bloom in Provence',
      description: 'Beautiful purple fields in full bloom'
    }, {
      month: 'Jul',
      name: 'Bastille Day',
      description: 'National holiday with fireworks and celebrations'
    }],
    climateScore: 85
  },
  Switzerland: {
    months: [{
      month: 'Jan',
      tempRange: '-4-2°C',
      rainfall: 'Moderate',
      icon: <CloudSnowIcon className="h-4 w-4" data-id="element-4346" />,
      season: 'Winter',
      description: 'Cold winter with snow in mountain regions, ideal for winter sports.'
    }, {
      month: 'Feb',
      tempRange: '-3-4°C',
      rainfall: 'Moderate',
      icon: <CloudSnowIcon className="h-4 w-4" data-id="element-4347" />,
      season: 'Winter',
      description: 'Cold temperatures with excellent skiing conditions.'
    }, {
      month: 'Mar',
      tempRange: '0-9°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4348" />,
      season: 'Spring',
      description: 'Early spring in lowlands, still winter in mountains.'
    }, {
      month: 'Apr',
      tempRange: '4-14°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4349" />,
      season: 'Spring',
      description: 'Spring flowers in valleys, last chance for skiing in higher altitudes.'
    }, {
      month: 'May',
      tempRange: '8-19°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4350" />,
      season: 'Spring',
      description: 'Pleasant spring weather with alpine flowers blooming.'
    }, {
      month: 'Jun',
      tempRange: '11-22°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4351" />,
      season: 'Summer',
      description: 'Early summer with warm days, ideal for hiking.'
    }, {
      month: 'Jul',
      tempRange: '13-25°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4352" />,
      season: 'Summer',
      description: 'Warm summer weather, occasional thunderstorms in mountains.'
    }, {
      month: 'Aug',
      tempRange: '13-24°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4353" />,
      season: 'Summer',
      description: 'Warm days with possibility of afternoon thunderstorms.'
    }, {
      month: 'Sep',
      tempRange: '10-20°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4354" />,
      season: 'Autumn',
      description: 'Pleasant autumn weather with clear mountain views.'
    }, {
      month: 'Oct',
      tempRange: '6-15°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4355" />,
      season: 'Autumn',
      description: 'Cooling temperatures with beautiful autumn colors.'
    }, {
      month: 'Nov',
      tempRange: '1-8°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4356" />,
      season: 'Autumn',
      description: 'Late autumn with possibility of first snow in mountains.'
    }, {
      month: 'Dec',
      tempRange: '-3-3°C',
      rainfall: 'Moderate',
      icon: <CloudSnowIcon className="h-4 w-4" data-id="element-4357" />,
      season: 'Winter',
      description: 'Winter begins with snow in mountain regions.'
    }],
    bestTimeToVisit: ['Dec', 'Jan', 'Feb', 'Jul', 'Aug', 'Sep'],
    specialEvents: [{
      month: 'Jan-Feb',
      name: 'International Balloon Festival',
      description: "Colorful hot air balloons fill the sky in Château-d'Oex"
    }, {
      month: 'Jul-Aug',
      name: 'Montreux Jazz Festival',
      description: 'World-renowned music festival on Lake Geneva'
    }, {
      month: 'Dec',
      name: 'Christmas Markets',
      description: 'Traditional markets with festive atmosphere in cities and towns'
    }],
    climateScore: 82
  },
  Maldives: {
    months: [{
      month: 'Jan',
      tempRange: '25-30°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4358" />,
      season: 'Dry',
      description: 'Perfect beach weather with low humidity and minimal rainfall.'
    }, {
      month: 'Feb',
      tempRange: '25-30°C',
      rainfall: 'Very Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4359" />,
      season: 'Dry',
      description: 'Excellent weather with clear skies and calm seas.'
    }, {
      month: 'Mar',
      tempRange: '26-31°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4360" />,
      season: 'Dry',
      description: 'Hot temperatures with very little rainfall.'
    }, {
      month: 'Apr',
      tempRange: '27-32°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4361" />,
      season: 'Transition',
      description: 'Hot temperatures with increasing humidity and occasional showers.'
    }, {
      month: 'May',
      tempRange: '27-31°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4362" />,
      season: 'Wet',
      description: 'Beginning of wet season with increasing rainfall.'
    }, {
      month: 'Jun',
      tempRange: '26-30°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4363" />,
      season: 'Wet',
      description: 'Wet season with frequent rainfall but still warm temperatures.'
    }, {
      month: 'Jul',
      tempRange: '26-30°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4364" />,
      season: 'Wet',
      description: 'Continuing wet season with possibility of extended rainy periods.'
    }, {
      month: 'Aug',
      tempRange: '26-30°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4365" />,
      season: 'Wet',
      description: 'Wet season continues with intermittent sunshine between showers.'
    }, {
      month: 'Sep',
      tempRange: '25-30°C',
      rainfall: 'Very High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4366" />,
      season: 'Wet',
      description: 'Peak of wet season with highest rainfall of the year.'
    }, {
      month: 'Oct',
      tempRange: '25-30°C',
      rainfall: 'Very High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4367" />,
      season: 'Wet',
      description: 'Heavy rainfall continuing, but beginning to decrease.'
    }, {
      month: 'Nov',
      tempRange: '25-30°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4368" />,
      season: 'Transition',
      description: 'Transition to dry season with decreasing rainfall.'
    }, {
      month: 'Dec',
      tempRange: '25-30°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4369" />,
      season: 'Dry',
      description: 'Early dry season with occasional showers and increasing sunshine.'
    }],
    bestTimeToVisit: ['Jan', 'Feb', 'Mar', 'Apr', 'Dec'],
    specialEvents: [{
      month: 'Jul',
      name: 'Independence Day',
      description: 'National celebrations throughout the islands'
    }, {
      month: 'Nov',
      name: 'Republic Day',
      description: 'Commemorates the founding of the Republic with parades and events'
    }, {
      month: 'Year-round',
      name: 'Underwater Festivals',
      description: 'Various diving and marine life events throughout the year'
    }],
    climateScore: 92
  },
  China: {
    months: [{
      month: 'Jan',
      tempRange: '-10-8°C',
      rainfall: 'Low',
      icon: <CloudSnowIcon className="h-4 w-4" data-id="element-4370" />,
      season: 'Winter',
      description: 'Cold winter with snow in northern regions, milder in south.'
    }, {
      month: 'Feb',
      tempRange: '-8-10°C',
      rainfall: 'Low',
      icon: <CloudSnowIcon className="h-4 w-4" data-id="element-4371" />,
      season: 'Winter',
      description: 'Cold temperatures continuing, Chinese New Year celebrations.'
    }, {
      month: 'Mar',
      tempRange: '-2-15°C',
      rainfall: 'Low',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4372" />,
      season: 'Spring',
      description: 'Early spring with warming temperatures, significant variation by region.'
    }, {
      month: 'Apr',
      tempRange: '5-20°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4373" />,
      season: 'Spring',
      description: 'Pleasant spring weather in most regions.'
    }, {
      month: 'May',
      tempRange: '10-25°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4374" />,
      season: 'Spring',
      description: 'Warm temperatures with increasing rainfall in southern regions.'
    }, {
      month: 'Jun',
      tempRange: '15-30°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4375" />,
      season: 'Summer',
      description: 'Early summer with increasing heat and humidity, rainy season begins in many areas.'
    }, {
      month: 'Jul',
      tempRange: '20-33°C',
      rainfall: 'Very High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4376" />,
      season: 'Summer',
      description: 'Hot and humid with heavy rainfall in many regions.'
    }, {
      month: 'Aug',
      tempRange: '20-33°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4377" />,
      season: 'Summer',
      description: 'Continuing hot and humid conditions with frequent rainfall.'
    }, {
      month: 'Sep',
      tempRange: '15-28°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4378" />,
      season: 'Autumn',
      description: 'Early autumn with decreasing rainfall and pleasant temperatures.'
    }, {
      month: 'Oct',
      tempRange: '8-23°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4379" />,
      season: 'Autumn',
      description: 'Pleasant autumn weather with clear skies and comfortable temperatures.'
    }, {
      month: 'Nov',
      tempRange: '0-18°C',
      rainfall: 'Low',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4380" />,
      season: 'Autumn',
      description: 'Late autumn with cooling temperatures.'
    }, {
      month: 'Dec',
      tempRange: '-8-12°C',
      rainfall: 'Low',
      icon: <CloudSnowIcon className="h-4 w-4" data-id="element-4381" />,
      season: 'Winter',
      description: 'Winter begins with cold temperatures, snow in northern regions.'
    }],
    bestTimeToVisit: ['Apr', 'May', 'Sep', 'Oct'],
    specialEvents: [{
      month: 'Jan-Feb',
      name: 'Chinese New Year',
      description: 'The most important traditional festival with celebrations nationwide'
    }, {
      month: 'Apr',
      name: 'Peach Blossom Festival',
      description: 'Beautiful peach blossoms in various regions'
    }, {
      month: 'Sep-Oct',
      name: 'Mid-Autumn Festival',
      description: 'Traditional harvest festival with mooncakes and lanterns'
    }],
    climateScore: 78
  },
  Peru: {
    months: [{
      month: 'Jan',
      tempRange: '15-25°C',
      rainfall: 'Very High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4382" />,
      season: 'Wet',
      description: 'Peak of wet season in the Andes, hot and humid in Amazon regions.'
    }, {
      month: 'Feb',
      tempRange: '15-25°C',
      rainfall: 'Very High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4383" />,
      season: 'Wet',
      description: 'Heavy rainfall continues, Inca Trail often closed for maintenance.'
    }, {
      month: 'Mar',
      tempRange: '15-25°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4384" />,
      season: 'Wet',
      description: 'Wet season beginning to taper off, lush green landscapes.'
    }, {
      month: 'Apr',
      tempRange: '10-25°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4385" />,
      season: 'Transition',
      description: 'Transition to dry season, decreasing rainfall and pleasant temperatures.'
    }, {
      month: 'May',
      tempRange: '10-24°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4386" />,
      season: 'Dry',
      description: 'Beginning of dry season with clear skies and comfortable temperatures.'
    }, {
      month: 'Jun',
      tempRange: '5-23°C',
      rainfall: 'Very Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4387" />,
      season: 'Dry',
      description: 'Dry season with cool nights and warm days in the Andes.'
    }, {
      month: 'Jul',
      tempRange: '5-22°C',
      rainfall: 'Very Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4388" />,
      season: 'Dry',
      description: 'Peak tourist season with excellent conditions for Machu Picchu.'
    }, {
      month: 'Aug',
      tempRange: '5-23°C',
      rainfall: 'Very Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4389" />,
      season: 'Dry',
      description: 'Continuing dry season with ideal conditions for trekking.'
    }, {
      month: 'Sep',
      tempRange: '8-24°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4390" />,
      season: 'Dry',
      description: 'Excellent weather continues with slightly warming temperatures.'
    }, {
      month: 'Oct',
      tempRange: '10-24°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4391" />,
      season: 'Transition',
      description: 'Beginning of transition to wet season, occasional showers.'
    }, {
      month: 'Nov',
      tempRange: '10-25°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4392" />,
      season: 'Wet',
      description: 'Increasing rainfall, landscapes becoming greener.'
    }, {
      month: 'Dec',
      tempRange: '15-25°C',
      rainfall: 'Very High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4393" />,
      season: 'Wet',
      description: 'Wet season with frequent rainfall, especially in the Andes.'
    }],
    bestTimeToVisit: ['May', 'Jun', 'Jul', 'Aug', 'Sep'],
    specialEvents: [{
      month: 'Jun',
      name: 'Inti Raymi',
      description: 'Festival of the Sun celebrated in Cusco with colorful ceremonies'
    }, {
      month: 'Jul-Aug',
      name: 'National Holidays',
      description: 'Independence celebrations throughout the country'
    }, {
      month: 'Oct-Nov',
      name: 'Lord of Miracles',
      description: 'Major religious processions in Lima'
    }],
    climateScore: 85
  },
  Morocco: {
    months: [{
      month: 'Jan',
      tempRange: '7-18°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4394" />,
      season: 'Winter',
      description: 'Mild in coastal areas, cold in mountains with snow possible in Atlas Mountains.'
    }, {
      month: 'Feb',
      tempRange: '8-19°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4395" />,
      season: 'Winter',
      description: 'Similar to January with slightly warming temperatures.'
    }, {
      month: 'Mar',
      tempRange: '10-22°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4396" />,
      season: 'Spring',
      description: 'Early spring with pleasant temperatures and wildflowers beginning to bloom.'
    }, {
      month: 'Apr',
      tempRange: '12-24°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4397" />,
      season: 'Spring',
      description: 'Warm days and cool evenings, excellent time for sightseeing.'
    }, {
      month: 'May',
      tempRange: '15-27°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4398" />,
      season: 'Spring',
      description: 'Warm temperatures with very little rainfall.'
    }, {
      month: 'Jun',
      tempRange: '18-31°C',
      rainfall: 'Very Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4399" />,
      season: 'Summer',
      description: 'Hot temperatures, especially inland and in desert regions.'
    }, {
      month: 'Jul',
      tempRange: '21-36°C',
      rainfall: 'Very Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4400" />,
      season: 'Summer',
      description: 'Very hot, particularly in inland cities and desert areas.'
    }, {
      month: 'Aug',
      tempRange: '21-36°C',
      rainfall: 'Very Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4401" />,
      season: 'Summer',
      description: 'Peak summer heat, coastal areas more comfortable than inland.'
    }, {
      month: 'Sep',
      tempRange: '19-32°C',
      rainfall: 'Very Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4402" />,
      season: 'Summer',
      description: 'Hot temperatures continuing but beginning to cool slightly.'
    }, {
      month: 'Oct',
      tempRange: '15-27°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4403" />,
      season: 'Autumn',
      description: 'Pleasant autumn weather with comfortable temperatures.'
    }, {
      month: 'Nov',
      tempRange: '11-22°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4404" />,
      season: 'Autumn',
      description: 'Cooling temperatures with increasing chance of rainfall.'
    }, {
      month: 'Dec',
      tempRange: '8-19°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4405" />,
      season: 'Winter',
      description: 'Winter begins with mild temperatures in lowlands, cold in mountains.'
    }],
    bestTimeToVisit: ['Mar', 'Apr', 'May', 'Oct', 'Nov'],
    specialEvents: [{
      month: 'Jan',
      name: 'Almond Blossom Festival',
      description: 'Celebration of almond blossoms in the Anti-Atlas Mountains'
    }, {
      month: 'May',
      name: 'Festival of Roses',
      description: 'Celebrates the rose harvest in the Valley of Roses'
    }, {
      month: 'Jul',
      name: 'National Folk Festival',
      description: 'Traditional music and dance performances in Marrakech'
    }],
    climateScore: 87
  },
  Caribbean: {
    months: [{
      month: 'Jan',
      tempRange: '22-28°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4406" />,
      season: 'Dry',
      description: 'Perfect beach weather with low humidity and minimal rainfall.'
    }, {
      month: 'Feb',
      tempRange: '22-28°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4407" />,
      season: 'Dry',
      description: 'Continuing excellent weather with sunny days and mild evenings.'
    }, {
      month: 'Mar',
      tempRange: '23-29°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4408" />,
      season: 'Dry',
      description: 'Warm temperatures with very little rainfall, peak tourist season.'
    }, {
      month: 'Apr',
      tempRange: '24-30°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4409" />,
      season: 'Dry',
      description: 'Late dry season with warm temperatures and clear skies.'
    }, {
      month: 'May',
      tempRange: '25-31°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4410" />,
      season: 'Transition',
      description: 'Beginning of transition to wet season, occasional afternoon showers.'
    }, {
      month: 'Jun',
      tempRange: '26-32°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4411" />,
      season: 'Wet',
      description: 'Early hurricane season, increasing humidity and rainfall.'
    }, {
      month: 'Jul',
      tempRange: '26-32°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4412" />,
      season: 'Wet',
      description: 'Hot temperatures with afternoon thunderstorms common.'
    }, {
      month: 'Aug',
      tempRange: '26-32°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4413" />,
      season: 'Wet',
      description: 'Peak of hurricane season, hot and humid with increased rainfall.'
    }, {
      month: 'Sep',
      tempRange: '26-32°C',
      rainfall: 'Very High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4414" />,
      season: 'Wet',
      description: 'Highest risk of hurricanes, frequent rainfall but still warm.'
    }, {
      month: 'Oct',
      tempRange: '25-31°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4415" />,
      season: 'Wet',
      description: 'Continuing wet season with hurricane risk still present.'
    }, {
      month: 'Nov',
      tempRange: '24-30°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4416" />,
      season: 'Transition',
      description: 'End of hurricane season, decreasing rainfall.'
    }, {
      month: 'Dec',
      tempRange: '23-29°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4417" />,
      season: 'Dry',
      description: 'Beginning of dry season with excellent beach weather returning.'
    }],
    bestTimeToVisit: ['Dec', 'Jan', 'Feb', 'Mar', 'Apr'],
    specialEvents: [{
      month: 'Feb-Mar',
      name: 'Carnival',
      description: 'Vibrant celebrations with music, dancing and colorful parades'
    }, {
      month: 'Jul-Aug',
      name: 'Crop Over Festival',
      description: "Barbados' biggest cultural celebration"
    }, {
      month: 'Dec',
      name: 'Junkanoo',
      description: 'Bahamian street parade with music, dance and elaborate costumes'
    }],
    climateScore: 90
  },
  Thailand: {
    months: [{
      month: 'Jan',
      tempRange: '20-32°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4418" />,
      season: 'Dry',
      description: 'Perfect weather with low humidity and minimal rainfall.'
    }, {
      month: 'Feb',
      tempRange: '22-33°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4419" />,
      season: 'Dry',
      description: 'Continuing excellent weather, temperatures beginning to rise.'
    }, {
      month: 'Mar',
      tempRange: '24-35°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4420" />,
      season: 'Hot',
      description: 'Hot season begins with rising temperatures and low humidity.'
    }, {
      month: 'Apr',
      tempRange: '25-36°C',
      rainfall: 'Moderate',
      icon: <CloudIcon className="h-4 w-4" data-id="element-4421" />,
      season: 'Hot',
      description: 'Peak of hot season with very high temperatures.'
    }, {
      month: 'May',
      tempRange: '25-34°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4422" />,
      season: 'Wet',
      description: 'Beginning of monsoon season with increasing rainfall.'
    }, {
      month: 'Jun',
      tempRange: '24-33°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4423" />,
      season: 'Wet',
      description: 'Wet season with frequent rainfall but still warm temperatures.'
    }, {
      month: 'Jul',
      tempRange: '24-33°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4424" />,
      season: 'Wet',
      description: 'Continuing wet season with regular rainfall.'
    }, {
      month: 'Aug',
      tempRange: '24-32°C',
      rainfall: 'Very High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4425" />,
      season: 'Wet',
      description: 'Peak of wet season with highest rainfall of the year.'
    }, {
      month: 'Sep',
      tempRange: '24-32°C',
      rainfall: 'Very High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4426" />,
      season: 'Wet',
      description: 'Continuing heavy rainfall, especially in central and northern regions.'
    }, {
      month: 'Oct',
      tempRange: '23-32°C',
      rainfall: 'High',
      icon: <CloudRainIcon className="h-4 w-4" data-id="element-4427" />,
      season: 'Wet',
      description: 'Late monsoon season with decreasing rainfall.'
    }, {
      month: 'Nov',
      tempRange: '22-31°C',
      rainfall: 'Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4428" />,
      season: 'Dry',
      description: 'Transition to dry season with decreasing rainfall and humidity.'
    }, {
      month: 'Dec',
      tempRange: '20-31°C',
      rainfall: 'Very Low',
      icon: <SunIcon className="h-4 w-4" data-id="element-4429" />,
      season: 'Dry',
      description: 'Beginning of the cool dry season with pleasant temperatures.'
    }],
    bestTimeToVisit: ['Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
    specialEvents: [{
      month: 'Apr',
      name: 'Songkran',
      description: 'Thai New Year celebrated with water festivals throughout the country'
    }, {
      month: 'Nov',
      name: 'Loy Krathong',
      description: 'Festival of Lights with floating offerings on rivers and lakes'
    }, {
      month: 'Feb',
      name: 'Chinese New Year',
      description: "Vibrant celebrations in Bangkok's Chinatown and other areas"
    }],
    climateScore: 86
  }
};
// Helper function to get destination weather data
export const getDestinationWeather = (destination: string) => {
  // Extract country from destination string
  const country = Object.keys(destinationWeather).find(country => destination.toLowerCase().includes(country.toLowerCase()));
  return country ? destinationWeather[country] : null;
};
// Temperature ranges for climate preference filtering
export const temperatureRanges = [{
  label: 'Cool (0-15°C)',
  min: 0,
  max: 15
}, {
  label: 'Mild (15-25°C)',
  min: 15,
  max: 25
}, {
  label: 'Warm (20-30°C)',
  min: 20,
  max: 30
}, {
  label: 'Hot (25°C+)',
  min: 25,
  max: 40
}];
// Function to match destinations to temperature preferences
export const findDestinationsForTemperature = (minTemp: number, maxTemp: number, month?: string) => {
  const matches: {
    destination: string;
    score: number;
  }[] = [];
  Object.entries(destinationWeather).forEach(([destination, data]) => {
    // If month is specified, check only that month
    if (month) {
      const monthData = data.months.find(m => m.month === month);
      if (monthData) {
        const [min, max] = monthData.tempRange.replace('°C', '').split('-').map(Number);
        // Check if the temperature range overlaps with preferred range
        if (!(max < minTemp || min > maxTemp)) {
          // Calculate match score based on overlap
          const overlapScore = Math.min(max, maxTemp) - Math.max(min, minTemp);
          const normalizedScore = overlapScore / (maxTemp - minTemp);
          matches.push({
            destination,
            score: normalizedScore * 100
          });
        }
      }
    }
    // Otherwise check all months and find the best matches
    else {
      let bestScore = 0;
      let bestMonths: string[] = [];
      data.months.forEach(monthData => {
        const [min, max] = monthData.tempRange.replace('°C', '').split('-').map(Number);
        if (!(max < minTemp || min > maxTemp)) {
          const overlapScore = Math.min(max, maxTemp) - Math.max(min, minTemp);
          const normalizedScore = overlapScore / (maxTemp - minTemp);
          if (normalizedScore > bestScore) {
            bestScore = normalizedScore;
            bestMonths = [monthData.month];
          } else if (normalizedScore === bestScore) {
            bestMonths.push(monthData.month);
          }
        }
      });
      if (bestScore > 0) {
        matches.push({
          destination,
          score: bestScore * 100,
          bestMonths
        });
      }
    }
  });
  // Sort by score descending
  return matches.sort((a, b) => b.score - a.score);
};
// Function to get seasonal recommendations
export const getSeasonalRecommendations = () => {
  const currentDate = new Date();
  const currentMonth = currentDate.toLocaleString('default', {
    month: 'short'
  });
  // Get destinations that are in their best season now
  const currentSeasonDestinations = Object.entries(destinationWeather).filter(([_, data]) => data.bestTimeToVisit.includes(currentMonth)).map(([destination, data]) => ({
    destination,
    reason: `Perfect weather right now with ${data.months.find(m => m.month === currentMonth)?.description.toLowerCase()}`,
    score: data.climateScore
  }));
  // Get destinations with upcoming special events
  const upcomingEvents = [];
  Object.entries(destinationWeather).forEach(([destination, data]) => {
    data.specialEvents.forEach(event => {
      const eventMonths = event.month.split('-');
      if (eventMonths.includes(currentMonth) || eventMonths.includes(getNextMonth(currentMonth)) || event.month === 'Year-round') {
        upcomingEvents.push({
          destination,
          event: event.name,
          description: event.description,
          when: event.month === 'Year-round' ? 'Year-round' : eventMonths.includes(currentMonth) ? 'Now' : 'Next month'
        });
      }
    });
  });
  return {
    inSeason: currentSeasonDestinations.sort((a, b) => b.score - a.score),
    upcomingEvents: upcomingEvents
  };
};
// Helper function to get the next month
const getNextMonth = (month: string) => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const index = months.indexOf(month);
  return months[(index + 1) % 12];
};
// Function to get weather recommendations
export const getWeatherRecommendations = (weatherPreference: string) => {
  let recommendations: {
    destination: string;
    reason: string;
  }[] = [];
  switch (weatherPreference) {
    case 'sunshine':
      recommendations = Object.entries(destinationWeather).filter(([_, data]) => {
        // Count months with sun icon
        const sunnyMonths = data.months.filter(m => m.icon.type.name === 'SunIcon').length;
        return sunnyMonths >= 6; // At least 6 months of sunshine
      }).map(([destination, data]) => ({
        destination,
        reason: `Abundant sunshine with ${data.months.filter(m => m.icon.type.name === 'SunIcon').length} sunny months per year`
      }));
      break;
    case 'escape-cold':
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      // If northern hemisphere winter (Nov-Mar)
      if (currentMonth >= 10 || currentMonth <= 2) {
        recommendations = Object.entries(destinationWeather).filter(([_, data]) => {
          const winterMonths = data.months.slice(0, 3).concat(data.months.slice(10, 12));
          // Check if winter months are warm
          return winterMonths.every(m => {
            const [min, _] = m.tempRange.replace('°C', '').split('-').map(Number);
            return min >= 20; // Minimum temp at least 20°C
          });
        }).map(([destination, data]) => ({
          destination,
          reason: `Warm winter escape with temperatures above 20°C when it's cold at home`
        }));
      } else {
        // For southern hemisphere winter (May-Sep)
        recommendations = Object.entries(destinationWeather).filter(([_, data]) => {
          const winterMonths = data.months.slice(4, 9);
          // Check if these months are warm
          return winterMonths.every(m => {
            const [min, _] = m.tempRange.replace('°C', '').split('-').map(Number);
            return min >= 20; // Minimum temp at least 20°C
          });
        }).map(([destination, data]) => ({
          destination,
          reason: `Warm destination while it's winter in the southern hemisphere`
        }));
      }
      break;
    case 'dry-season':
      recommendations = Object.entries(destinationWeather).map(([destination, data]) => {
        // Find consecutive dry months
        let longestDryStreak = 0;
        let currentStreak = 0;
        let dryMonths: string[] = [];
        data.months.forEach(month => {
          if (['Very Low', 'Low'].includes(month.rainfall)) {
            currentStreak++;
            if (currentStreak > longestDryStreak) {
              longestDryStreak = currentStreak;
              dryMonths = [month.month];
            } else if (currentStreak === longestDryStreak) {
              dryMonths.push(month.month);
            }
          } else {
            currentStreak = 0;
          }
        });
        return {
          destination,
          dryStreak: longestDryStreak,
          dryMonths
        };
      }).filter(item => item.dryStreak >= 3) // At least 3 consecutive dry months
      .map(item => ({
        destination: item.destination,
        reason: `Extended dry season with ${item.dryStreak} consecutive months of minimal rainfall`
      }));
      break;
  }
  return recommendations;
};